<div
  class="bg-white fixed top-0 bottom-0 left-0 right-0 h-screen flex justify-center items-center"
  [style.z-index]="(index$ | async) + 90"
>
  <div class="text-md md:text-xl lg:text-4xl">
    {{ 'waiting-modal.please-wait' | translate }}
  </div>
</div>
